import type { NodeId, NodeRecord } from '@ipfabric/utils';

export const addExpandedHiddenHosts =
  (nodes: NodeRecord, oldNodes?: NodeRecord) =>
  (hiddenNodes: Set<NodeId>): Set<NodeId> => {
    if (!oldNodes) {
      return hiddenNodes;
    }

    const expandedHiddenNodeIds: Set<NodeId> = new Set(hiddenNodes);
    const oldNodeIds = Object.keys(oldNodes);

    for (const id of hiddenNodes) {
      const node = nodes[id];

      if (!node) {
        continue;
      }

      // Hide only children expanded in current load
      for (const childId of node.children) {
        if (!oldNodeIds.includes(childId)) {
          expandedHiddenNodeIds.add(childId);
        }
      }
    }

    return expandedHiddenNodeIds;
  };
